import { MdlPopoverComponent } from '@angular-mdl/popover';
import { ChangeDetectionStrategy, Component, Input, OnChanges, ViewChild } from '@angular/core';
import { FormControl, ValidatorFn, Validators } from '@angular/forms';
import { isEmpty } from 'lodash';
import { forbiddenValueError, forbidValues, maxBytesError, maxLengthInBytes, notNullOrWhiteSpace } from '../shared/validators';

@Component({
    selector: 'covance-textfield',
    template: require('./covance-textfield.component.html'),
    styles: [require('./covance-textfield.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CovanceTextFieldComponent implements OnChanges {
    @Input()
    public control: FormControl;

    @Input()
    public label: string;

    @Input()
    public isRequired = true;

    @Input()
    public suggestions: string[] = [];

    @Input()
    public isLoadingSuggestions = false;

    @Input()
    public maxBytesCount: number | null;

    @Input()
    public maxSymbolsCount: number | null;

    @Input()
    public forbiddenValues: string[] = null;

    @ViewChild('suggestionsPopover')
    public suggestionsPopover: MdlPopoverComponent;

    public get errorMessage() {
        if (this.control.hasError('required')) {
            return 'This field is required';
        }
        if (this.control.hasError('maxlength') || this.control.hasError(maxBytesError)) {
            return 'Value is too long';
        }
        if (this.control.hasError(forbiddenValueError)) {
            return 'Value is forbidden';
        }
        return '';
    }

    public get hasSuggestions() {
        return !isEmpty(this.suggestions);
    }

    public ngOnChanges() {
        const validators: ValidatorFn[] = [];

        if (this.isRequired) {
            validators.push(notNullOrWhiteSpace());
        }
        if (this.maxSymbolsCount) {
            validators.push(Validators.maxLength(this.maxSymbolsCount));
        }
        if (this.maxBytesCount) {
            validators.push(maxLengthInBytes(this.maxBytesCount));
        }
        if (this.forbiddenValues) {
            validators.push(forbidValues(this.forbiddenValues));
        }
        
        this.control.setValidators(validators);
        this.control.updateValueAndValidity(); 
    }

    public onSuggestionClick(suggestion: string) {
        this.control.setValue(suggestion);
        this.suggestionsPopover.toggle(null);
    }
}